/* eslint-disable max-lines */
import React from "react";
import isTouchDevice from "is-touch-device";
import styles from "./adCard.scss";
import confirmModal from "../../services/confirmModal";
import AdSummary from "./AdSummary/AdSummary";
import { AdLink } from "./AdLink";
import { CoverImage } from "./CoverImage";
import { DeletedCard } from "./DeletedCard";
import { AdStatus, CategoryName, CategoryNameHr, LinkTargetEnum } from "../../models";
import { AdActions } from "./AdActions";
import AdMoreMenu from "./AdMoreMenu/AdMoreMenu";
import { AdStatusLabel } from "./AdStatusLabel";
// import { AdSummaryBottom } from "./AdSummary/AdSummaryBottom";
import { AdVisitedLabel } from "./AdVisitedLabel";
import FavoriteButtonWhite from "../../containers/FavoriteButtonWhite";
import { AdYouTube } from "./AdYouTube";
import { Icon } from "antd";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import config from "appConfig";
import { getAdUrl, getSearchAdCardId, getUrlParams, setLastClickedSearchAd } from "../../services/utils";
import { QueryParam } from "../../models";

function AdCard(props: any) {
  const {
    ad,
    buttonComponents,
    adLists,
    hasFavorite,
    isCheckStatus,
    onEdit,
    onDelete,
    onActive,
    onPaused,
    onSold,
    hasVisitedLabel,
    showActions,
    isMobile,
    className,
    showDetails = true,
    bottomSection = false,
    target,
    shouldHilightPromotedAds,
    handleNote,
    listIndex,
    rememberLastClicked,
  } = props;

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const searchType = urlParams.get("search_type") || "";
  const searchQuery = urlParams.get("search_query") || "";
  const searchQueryParsed = getUrlParams(location.search, QueryParam.searchQuery);
  const searchPage = (searchQueryParsed && searchQueryParsed.page) ? Number(searchQueryParsed.page) : 1;

  const handleAdClickTracking = () => {
    if (searchType) {
      const absolutePosition = listIndex != null
        ? (searchPage - 1) * config.maxAdPerPage + listIndex + 1
        : undefined;
      ReactGA.event("search_result_click", {
        search_type: searchType,
        search_query: searchQuery,
        sortOption: searchQueryParsed && searchQueryParsed.sortOption,
        ad_id: ad.id,
        ad_position: absolutePosition,
        search_page: searchPage,
        is_promoted: ad.isPromoted || false,
      });
    }
  };

  const preventDefaultClick = (event: any) => {
    if (!event) {
      return;
    }

    event.preventDefault();
  };

  const isTouchScreen = isTouchDevice();

  const adActions = {
    onEdit: (e: any) => {
      preventDefaultClick(e);
      onEdit(ad.id, ad.module);
    },
    onDelete: (e: any) => {
      preventDefaultClick(e);
      confirmModal.show({
        title: "Izbriši oglas",
        okText: "U redu",
        cancelText: "Otkaži",
        iconType: "NaN",
        onOk() {
          onDelete(ad.id);
        },
        children: "Jeste li sigurni da želite izbrisati oglas?"
      });
    },
    onActive: (e: any) => {
      preventDefaultClick(e);
      onActive(ad.id);
    },
    onPaused: (e: any) => {
      preventDefaultClick(e);
      onPaused(ad.id);
    },
    onSold: (e: any) => {
      preventDefaultClick(e);
      onSold(ad.id);
    }
  };

  const renderFavoriteButton = () => {
    if (!hasFavorite) {
      return null;
    }

    return (
      <span className={styles.bottomButtonContainer}>
        <FavoriteButtonWhite adLists={adLists} ad={ad} />
      </span>
    );
  };

  const isPersonalCar = ad.category === CategoryName.car || ad.category === CategoryNameHr.car;
  const featuredLabel = isPersonalCar && ad.featuredProperty && ad.featuredProperty.label;

  // Desktop stacks both pills on the cover image; on mobile the featured
  // pill moves inline into the summary (rendered by AdSummary) so it sits
  // next to the price without covering the photo.
  const renderCoverBadges = () => {
    const showFeatured = featuredLabel && !isMobile;
    if (!showFeatured && !ad.priceReductionPercentage) {
      return null;
    }
    return (
      <div className={styles.badges}>
        {showFeatured && (
          <span className={styles.featuredProperty}>{featuredLabel}</span>
        )}
        {ad.priceReductionPercentage && (
          <span className={styles.percentage}>{ad.priceReductionPercentage}%</span>
        )}
      </div>
    );
  };

  const isShowDeletedAd = isCheckStatus
    ? ad.status === AdStatus.paused ||
    ad.status === AdStatus.sold ||
    ad.status === AdStatus.deleted ||
    ad.status === AdStatus.expired ||
    ad.status === AdStatus.blocked
    : false;

  return isShowDeletedAd ? (
    <DeletedCard
      ad={ad}
      defaultButtons={buttonComponents}
      adCardProps={props}
      onContainerClick={preventDefaultClick}
    />
  ) : (
    <AdLink
      ad={ad}
      onClick={() => {
        handleAdClickTracking();
        if (rememberLastClicked) {
          setLastClickedSearchAd(ad.id, getAdUrl(ad));
        }
        if (props.onClick) props.onClick();
      }}
      className=""
      target={target}
      listIndex={listIndex}
      id={rememberLastClicked ? getSearchAdCardId(ad.id) : undefined}
    >
      <div
        className={`
          ${isMobile ? styles.cardMobile : styles.card} ${className}
          ${shouldHilightPromotedAds && ad.isPromoted ? styles.promoted : ""}
        `}
      >
        <div className={styles.cardContainer}>
          <div className={styles.coverImageContainer}>
            <CoverImage ad={ad} />
            {showActions ? <AdStatusLabel status={ad.status} /> : null}

            {ad.videoUrl && adLists.search &&
              <AdYouTube isSearchPage={adLists.search} />
            }

            {renderCoverBadges()}

            {hasVisitedLabel && ad.isRead ? (
              <AdVisitedLabel isMobile={isMobile} />
            ) : null}
            {bottomSection && !isMobile ? null : renderFavoriteButton()}
          </div>

          <div
            className={
              isMobile ? styles.summaryContainerMobile : styles.summaryContainer
            }
          >
            <AdSummary
              ad={ad}
              className={showActions && !isTouchScreen ? styles.summary : ""}
              hasFavorite={hasFavorite}
              adLists={adLists}
              isMobile={isMobile}
              category={props.category}
              showDetails={showDetails}
              bottomSection={bottomSection}
              shouldHilightPromotedAds={shouldHilightPromotedAds}
              handleNote={handleNote}
              featuredLabel={featuredLabel}
            />
            {!isMobile && !bottomSection && (
              <div className={styles.cardFooter}>
                <span className={styles.legalEntity}>{ad.legalEntity ? "Poslovni prodavač" : "Privatni prodavač"}</span>
                {shouldHilightPromotedAds && ad.isPromoted && (
                  <span className={styles.promotedLabel}>Promoviran</span>
                )}
              </div>
            )}
            {showActions && !isTouchScreen && (
              <AdActions
                ad={ad}
                adActions={adActions}
                onViewClick={props.onClick}
                className={styles.actions}
              />
            )}
          </div>
        </div>

        {handleNote && ad.note ? (
          <div className={styles.cardNoteContainer}>
            <div className={styles.cardNote} onClick={(e) => handleNote(e, ad)}>
              {ad.note}
            </div>
            <Icon type="edit" className={styles.cardNoteIcon} onClick={(e) => handleNote(e, ad)} />
          </div>
        ) : null}

        {handleNote && isMobile && !ad.note ? (
          <span className={styles.bottomButtonContainerNote} onClick={(e) => handleNote(e, ad)}>
            <span className={styles.notesText}>Bilješka</span>
            <Icon type="edit" className={styles.notesIcon} />
          </span>
        ) : null}

        {/* {isMobile ? (
          <AdSummaryBottom
            ad={ad}
            adLists={adLists}
            hasFavorite={hasFavorite}
            className={styles.adBottom}
            category={props.category}
            />
        ) : null} */}

        {showActions && isTouchScreen ? (
          <AdMoreMenu
            adActions={adActions}
            ad={ad}
            onDropwdownContainerClick={preventDefaultClick}
          />
        ) : null}

        {isMobile && shouldHilightPromotedAds && ad.isPromoted && (
          <span className={styles.promotedLabelMobile}>Promoviran</span>
        )}

      </div>
    </AdLink>
  );
}

AdCard.defaultProps = {
  buttonComponents: [],
  onClick: () => null,
  hasFavorite: false,
  isCheckStatus: false,
  onEdit: () => null,
  onDelete: () => null,
  onActive: () => null,
  onPaused: () => null,
  onSold: () => null,
  hasVisitedLabel: false,
  showActions: false,
  isMobile: false,
  className: "",
  adLists: {},
  listIndex: null,
  rememberLastClicked: false,
};

export default AdCard;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdCard.tsx